import React from 'react';
import { Box } from '@hover/blueprint';
import TrustedByNamesDesktop from './TrustedByNamesDesktop';
import TrustedByNameTablet from './TrustedByNameTablet';
import TrustedByNameMobile from './TrustedByNameMobile';

const HomePageTrustedByNames: React.FC = () => (
  <Box maxW="8xl" w="100%">
    <TrustedByNamesDesktop />
    <TrustedByNameTablet />
    <TrustedByNameMobile />
  </Box>
);

export default HomePageTrustedByNames;
